export default "__VITE_ASSET__jJxcvKhX__"